import { createMuiTheme } from '@material-ui/core'
import {
  MuiButton,
  MuiTypography,
  MuiDialogGroup,
  MuiInput,
  MuiChip,
  MuiListItem,
  MuiTabs,
  MuiTab,
  MuiExpansionPanel,
  MuiExpansionPanelSummary,
  MuiExpansionPanelDetails,
  MuiCheckbox,
  MuiFormLabel,
} from '../overrides'

export const themeConstructor = (palette: any) =>
  createMuiTheme({
    typography: {
      fontFamily: ['knowledge2017regular', 'Arial'].join(','),
      useNextVariants: true,
    },
    palette,
    overrides: {
      ...MuiDialogGroup,
      MuiTypography,
      MuiButton,
      MuiExpansionPanel,
      MuiExpansionPanelSummary,
      MuiExpansionPanelDetails,
      MuiFormLabel,
      MuiInput: MuiInput(palette),
      MuiChip: MuiChip(palette),
      MuiMenuItem: MuiListItem(palette),
      MuiTabs: MuiTabs(palette),
      MuiTab: MuiTab(palette),
      MuiCheckbox: MuiCheckbox(palette),
    },
  })
